import Service from "../service";
import AuthService from "../AuthService";

const Report = {
  getStatReport(page) {
    return AuthService.get('/api/get-stat-print-report?page='+page);
    // return AuthService.get('/api/print-report');
  },
  getHistoryOrder(page) {
    // return AuthService.get('/api/print-report');
    return AuthService.get('/api/get-history-print-report?page='+page);
  },
  getToolNotPrintOverFiveYear(page) {
    return AuthService.get('/api/get-tool-not-print?page='+page)
  },
  getSearchStatReport(page,main_group,start_date,end_date) {
    return AuthService.get('/api/get-search-stat-report?page='+page+'&main_group=' + main_group +
      '&start_date=' + start_date +
      '&end_date=' + end_date)
  },
  changeOrderStatus(data) {
    return AuthService.post(`/api/update-status-order`, data)
    // return AuthService.post(`/api/change-order-status`, data)
  },
  getHistoryOrderSearch(page,order_id,status,date_start,date_end) {
    if(!order_id) {
      order_id = '';
    }
    if(!status) {
      status = '';
    }
    if(!date_start) {
      date_start = '';
    }
    if(!date_end) {
      date_end = '';
    }
    return AuthService.get('/api/get-history-order-search?page='+page+'&order_id='+order_id+
      '&status='+status+
      '&date_start='+date_start+
      '&date_end='+date_end
    )
  },
  getSearchNotOrder(page,date_start,date_end) {
    return AuthService.get('/api/get-not-order-search?page='+page+'&date_start='+date_start+
      '&date_end='+date_end
    )
  }
};

export default Report;
